import styled from 'styled-components';
import Input from '../../Atoms/Input/Input';
import Text from '../../Atoms/Text/Text';
import spacing from '../../../theme/shared/spacing';
import { media } from '../../../theme/shared/size';
import Picture from '../../Atoms/Picture/Picture';
import zIndex from '../../../theme/shared/zIndex';
var Container = styled.div.withConfig({
  displayName: "Donatestyle__Container",
  componentId: "sc-8rjm3t-0"
})(["background-color:", ";position:relative;display:flex;justify-content:center;height:auto;", "{align-items:center;justify-content:inherit;}"], function (_ref) {
  var theme = _ref.theme,
      backgroundColor = _ref.backgroundColor;
  return theme.color(backgroundColor);
}, media('medium'));
var BgImage = styled(Picture).withConfig({
  displayName: "Donatestyle__BgImage",
  componentId: "sc-8rjm3t-1"
})(["position:absolute;bottom:0;left:0;right:0;height:100%;opacity:0.4;"]);
var Wrapper = styled.div.withConfig({
  displayName: "Donatestyle__Wrapper",
  componentId: "sc-8rjm3t-2"
})(["position:relative;text-align:center;padding:", " ", ";flex-direction:row;display:block;width:100%;flex-direction:", ";", "{padding:", " ", ";}", "{display:flex;padding:", " 0;}"], spacing('l'), spacing('md'), function (_ref2) {
  var formAlignRight = _ref2.formAlignRight;
  return formAlignRight === true ? 'row-reverse' : 'row';
}, media('small'), spacing('xl'), spacing('md'), media('medium'), spacing('xl'));
var Header = styled.div.withConfig({
  displayName: "Donatestyle__Header",
  componentId: "sc-8rjm3t-3"
})(["width:100%;display:flex;", "{width:50%;padding:", ";align-items:center;}"], media('medium'), spacing('xl'));
var HeaderInner = styled.div.withConfig({
  displayName: "Donatestyle__HeaderInner",
  componentId: "sc-8rjm3t-4"
})(["position:relative;text-align:left;"]);
var FormWrapper = styled.div.withConfig({
  displayName: "Donatestyle__FormWrapper",
  componentId: "sc-8rjm3t-5"
})(["position:relative;", "{width:50%;}"], media('medium'));
var Error = styled(Text).withConfig({
  displayName: "Donatestyle__Error",
  componentId: "sc-8rjm3t-6"
})(["color:", ";font-size:", ";font-weight:500;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.color('red');
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize('s');
});
var Form = styled.form.withConfig({
  displayName: "Donatestyle__Form",
  componentId: "sc-8rjm3t-7"
})(["position:relative;width:100%;background-color:", ";box-shadow:0px 0px 16px rgba(0,0,0,0.15);border-radius:10px;margin-top:", ";h3{margin-top:", ";}input{max-width:100%;margin:0;}", "{width:450px;margin-right:auto;margin-left:auto;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.color('white');
}, spacing('md'), spacing('md'), media('small'));
var OuterFieldset = styled.fieldset.withConfig({
  displayName: "Donatestyle__OuterFieldset",
  componentId: "sc-8rjm3t-8"
})(["padding:0 ", " ", ";margin:0;border:none;", "{padding:0 ", " ", ";}"], spacing('md'), spacing('md'), media('small'), spacing('l'), spacing('l'));
var Legend = styled.legend.withConfig({
  displayName: "Donatestyle__Legend",
  componentId: "sc-8rjm3t-9"
})(["margin:0;padding:", " ", ";display:block;width:100%;"], spacing('l'), spacing('sm'));
var MoneyBuys = styled.div.withConfig({
  displayName: "Donatestyle__MoneyBuys",
  componentId: "sc-8rjm3t-10"
})(["display:flex;justify-content:space-between;flex-direction:column;margin-bottom:", ";", "{flex-direction:row;}label{flex:0 0 30%;margin-bottom:", ";", "{margin-bottom:0;}input{cursor:pointer;}}"], spacing('l'), media('small'), spacing('sm'), media('small'));
var FormFieldset = styled.div.withConfig({
  displayName: "Donatestyle__FormFieldset",
  componentId: "sc-8rjm3t-11"
})(["display:flex;align-items:center;justify-content:center;"]);
var Label = styled(Text).withConfig({
  displayName: "Donatestyle__Label",
  componentId: "sc-8rjm3t-12"
})(["margin-right:", ";"], spacing('sm'));
var AmountField = styled(Input).withConfig({
  displayName: "Donatestyle__AmountField",
  componentId: "sc-8rjm3t-13"
})(["position:relative;flex-basis:50%;flex-shrink:0;flex-grow:0;font-weight:400;display:block;", "{flex-basis:60%;}span{position:absolute;font-size:20px;top:50%;transform:translateY(-50%);left:0px;font-weight:500;padding:0px 15px;", ";}input{height:48px;border:2px solid ", ";background:", ";border-radius:10px;padding:", " ", " ", " ", ";&:focus{outline:none;border:2px solid ", ";}}"], media('small'), zIndex('low'), function (_ref6) {
  var theme = _ref6.theme;
  return theme.color('grey');
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.color('grey_light');
}, spacing('sm'), spacing('md'), spacing('sm'), spacing('l'), function (_ref8) {
  var theme = _ref8.theme;
  return theme.color('grey');
});
var Copy = styled(Text).withConfig({
  displayName: "Donatestyle__Copy",
  componentId: "sc-8rjm3t-14"
})(["line-height:1.5;"]);
var Button = styled.button.withConfig({
  displayName: "Donatestyle__Button",
  componentId: "sc-8rjm3t-15"
})(["width:100%;margin:", " 0 ", ";color:", ";font-size:", ";font-weight:bold;cursor:pointer;min-height:48px;background:", ";text-decoration:none;border-radius:2rem;border:none;box-shadow:0px 0px 16px rgba(0,0,0,0.15);:active,:focus,:hover{outline:none;background-color:", ";}", "{padding:", " ", ";}"], spacing('l'), spacing('l'), function (_ref9) {
  var theme = _ref9.theme;
  return theme.color('white');
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSize('s');
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.color('red');
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.color('coral_dark');
}, media('small'), spacing('md'), spacing('l'));
export { BgImage, Button, Copy, Container, Error, FormFieldset, FormWrapper, Header, HeaderInner, Label, Wrapper, Form, MoneyBuys, AmountField, OuterFieldset, Legend };